var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"box"},[_c('span',{on:{"click":_vm.goBack}}),_c('img',{attrs:{"src":require("../../assets/img/jieshao.png"),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }